import { THEME_STORAGE_KEY } from '@semai-soft.net/theme-ngx';
import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
  isDevMode,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideServiceWorker } from '@angular/service-worker';
import { appRoutes } from './app.routes';
import { PwaService } from './common/pwa.service';
import { authInterceptor } from './core/auth/auth.interceptor';

import { initCSSRuntime } from '@master/css-runtime';
import { waitHereFor } from '@semai-soft.net/common-x';
initCSSRuntime({});

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideIonicAngular({ mode: 'ios' }),
    provideAnimationsAsync(),
    provideAppInitializer(async() => {
      inject(PwaService).initPwaPrompt();
    }),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    { provide: THEME_STORAGE_KEY, useValue: 'cin-web-theme' },
  ],
};
